import TemplatePage, {TemplatePageProps} from "../template_page/template_page";

class EventPage extends TemplatePage {
    constructor(props: TemplatePageProps) {
        super(props);
        this.microformatsPageType = "h-event";
    }
}

export default EventPage;